import { createContext } from "react";

/**
 * The value passed into the `ValidityGroupContext` provider.
 */
export interface ValidityGroupContextValue {
  /**
   * Indicates whether invalid.
   */
  readonly invalid: boolean;

  /**
   * The validation error.
   */
  readonly error?: string | null;
}

/**
 * The `ValidityGroup` context.
 */
export const ValidityGroupContext = createContext<ValidityGroupContextValue>({
  invalid: false,
  error: undefined,
});
